exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".certificate-list-page a{color:#7ab6f7;width:100%}.link{right:-128px}.links{right:-25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/CertificatePages/certificatePage.scss
// module id = 1671
// module chunks = 0